import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=2a25bb2b&"
import script from "./WhyUs.vue?vue&type=script&lang=js&"
export * from "./WhyUs.vue?vue&type=script&lang=js&"
import style0 from "./WhyUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports